<template>
  <gravy-modal
      v-on:modal:cancel="open = false"
      v-on:modal:perform="$emit('modal:perform')"
      :open="open">
   <template v-slot:icon>
       <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
         <CheckIcon class="text-green-600" />
       </div>
   </template>
    <template v-slot:title>
       {{ title }}
    </template>
    <template v-slot:content>
       {{ content }}
    </template>
    <template v-slot:cancelButton>
        <neutral-button type="button"
                        :text="cancelButtonText"
                        @click="$emit('modal:cancel')" ref="cancelButtonRef">
          Cancel
        </neutral-button>
    </template>
    <template v-slot:actionButton>
        <primary-button :text="actionButtonText" @click="$emit('modal:perform')">

        </primary-button>
    </template>
  </gravy-modal>
</template>

<script>
import GravyModal from "@/components/Functional/Modal/GravyModal";
import { CheckIcon } from '@heroicons/vue/outline'
import NeutralButton from "@/components/Functional/Buttons/NeutralButton";
import PrimaryButton from "@/components/Functional/Buttons/PrimaryButton";
export default {
  name: "GeneralModal",
  components: {
    GravyModal,
    CheckIcon,
    NeutralButton,
    PrimaryButton
  },
  props: {
    open: {},
    title: {},
    content: {},
    cancelButtonText: {},
    actionButtonText: {},
  },
  emits: ['modal:cancel', 'modal:perform'],
}
</script>

<style scoped>

</style>